import IMerchantOrder from "@/module/main/dto/IMerchantOrder";
import IBrokeredOrder from "@/module/main/dto/IBrokeredOrder";

export default class BrokeredOrder implements IBrokeredOrder
{
    constructor(
        public merchantOrders: [IMerchantOrder]
    )
    {
    }
}
